import { render, staticRenderFns } from "./DiagnosticsPast.vue?vue&type=template&id=529fea6c&"
import script from "./DiagnosticsPast.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsPast.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsPast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports